"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("../less/index.less");
var preact_1 = require("preact");
var routes_1 = require("./pages/routes");
(0, preact_1.render)(routes_1.default, document.getElementById('jsx-wrapper'));
